import React, { Component } from 'react';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
import { DropdownMenu, Tooltip } from '@paypalcorp/pp-react';

class BasicSelectField extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    id: PropTypes.string,
    options: PropTypes.array,
    tooltipContent: PropTypes.string,
    tooltipId: PropTypes.string,
    className: PropTypes.string,
    menuContainerClassName: PropTypes.string,
    helperText: PropTypes.string,
  };

  state = {
    selectedProgramIdx: this.props.options.findIndex(
      (option) => option.value === this.props.input.value
    ),
  };

  handleChange = (index) => {
    this.setState({
      selectedProgramIdx: index,
    });
    const value = this.props.options[index].value;
    this.props.input.onChange(value);
  };

  render() {
    const {
      label,
      meta: { touched, error },
      id,
      className,
      menuContainerClassName = '',
    } = this.props;

    const hasError = touched && error;

    const options = _map(this.props.options, (option) => {
      return {
        primaryText: option.displayValue,
      };
    });

    return (
      <div className={this.props.tooltipContent ? 'dropdown-menu_tooltip' : ''}>
        <DropdownMenu
          type="button"
          label={label}
          aria-label={label}
          errorText={`${hasError ? 'Need an error msg?' : ''}`}
          options={options}
          id={id}
          onSelection={this.handleChange}
          selectedItemIndex={this.state.selectedProgramIdx}
          className={className}
          menuContainerClassName={menuContainerClassName}
          helperText={this.props.helperText ?? ''}
        />
        {this.props.tooltipContent && (
          <Tooltip
            name={this.props.tooltipId}
            description={this.props.tooltipContent}
          />
        )}
      </div>
    );
  }
}

export default BasicSelectField;
